// Splide init
function mmInitSplide() {
    const id = ".mm-dc-slider";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        // Drag natif qui suit le doigt (comme les carrousels du site) : on
        // privilégie l'usabilité. wheel retiré, easing doux. Un swipe normal
        // passe 1 ; un très long glissement peut en passer 2 (accepté).
        new Splide(splideElem, {
            type: "loop",
            pagination: false,
            arrows: false,
            drag: true,
            perMove: 1,
            speed: 400,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            gap: 12,
            fixedWidth: "240px",
            padding: {
                left: 20,
            },
        }).mount();
    }

    const idRea = ".splide-mm-cart-rea";
    const splideElemRea = document.querySelector(idRea);

    if (splideElemRea) {
        new Splide(splideElemRea, {
            type: "loop",
            pagination: true,
            autoplay: true,
            interval: 7000,
            speed: 900,
            arrows: false,
            gap: 12,
            perPage: 1,
            padding: {
                left: 20,
            },
        }).mount();
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
    },
    { once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    el.innerHTML = data.sections["mm-cart"];

    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products").classList.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: body ? JSON.stringify(body) : undefined,
    })
        .then((response) => response.json())
        .then((data) => {
            document.querySelector(".mm-dc-products").classList.remove("mm-inactive");
            if (mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner")) {
                const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
                const newWidth = (data.total_price / document.getElementById("mmCartProgressBarValue").value) * 100;
                freeItemsProgress.style.width = `${newWidth}%`;

                if (data.total_price >= document.getElementById("mmCartProgressBarValue").value) {
                    document.querySelector(".mm-dc-free-item-progress-text_succes").style.display = "block";
                    document.querySelector(".mm-dc-free-item-progress-text_not_yet").style.display = "none";
                } else {
                    document.querySelector(".mm-dc-free-item-progress-text_succes").style.display = "none";
                    document.querySelector(".mm-dc-free-item-progress-text_not_yet").style.display = "block";
                }
                const montantRestant = document.querySelector(".mm-dc-free-item-progress-text span");
                if (montantRestant) {
                    montantRestant.innerText = ((document.getElementById("mmCartProgressBarValue").value - data.total_price) / 100).toFixed(2);
                }
            }
            updateCartCount(data.item_count != null ? data.item_count : 0);
            return data;
        })
        .then((data) => {
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    mmAPIRequest("GET", "cart.js").then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    updateCartCount(newCartEl.querySelector("[data-cart-count]").dataset.cartCount);
    mmInitSplide();
    mmAddOrRemoveActivationProduct(data);
    // Offre Rentrée 2026 : hook du sélecteur d'accessoire offert (gr-gift-rentree.js)
    if (typeof window.grGiftOnCartUpdate === "function") {
        window.grGiftOnCartUpdate(data);
    }
}

/*
// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
    mmDisableCheckout(true)
    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: productId }],
        sections: "mm-cart",
    })
        .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .then(mmDisableCheckout(false))
        .catch((error) => {
            mmCartProductsContainerElement().innerHTML = `
        Oups, il y a eu une erreur, essayez de recharger la page !
        `;
            mmOpenCart();
            console.log(error);
        });
}*/
function mmAddProductToCart(productId, { quantity = 1, openCart = true, force = false }) {
    mmDisableCheckout(true);

    // N'ajoute que si le produit n'est pas deja au panier. La comparaison est
    // coercee en Number : les boutons qui passent l'id via dataset (offer_selector)
    // envoient une STRING, et l'ancien === strict ne matchait jamais, donc chaque
    // clic re-ajoutait une ligne. force=true saute la garde (frais d'activation,
    // qui doivent pouvoir s'incrementer).
    mmAPIRequest("GET", "cart.js", null)
        .then(cart => {
            const isProductInCart = !force && cart.items.some(item => Number(item.id) === Number(productId));

            if (!isProductInCart) {
                return mmAPIRequest("POST", "cart/add.js", {
                    items: [{ quantity: quantity, id: productId }],
                    sections: "mm-cart",
                })
                    .then(refreshCartFromData)
                    .then((data) => {
                        Promise.resolve()
                    })
                    .then(mmDisableCheckout(false))
                    .catch((error) => {
                        mmCartProductsContainerElement().innerHTML = `
                    Oups, il y a eu une erreur, essayez de recharger la page !
                    `;
                        setTimeout(mmOpenCart);
                    });
            }

            return Promise.resolve()
        })
        .then(data => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch(error => {
             mmCartProductsContainerElement().innerHTML = `
        Oups, il y a eu une erreur, essayez de recharger la page !
        `;
            setTimeout(mmOpenCart);
            console.log(error);
        })
        .finally(() => {
            mmDisableCheckout(false);
        });
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseActivationProductQuantity(productVariantId, qtty) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - qtty;
    console.log("quantity", quantity);
    console.log("qtty", qtty);
    console.log("new quantity", newQuantity);
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

// Lignes du groupe d'une rangée (les remises auto BXGY splittent une même variante
// en plusieurs lignes panier : la rangée affiche la somme, data-group-keys liste
// les lignes réelles au format "key:qty,key:qty,").
function mmParseGroupKeys(raw) {
    return (raw || "")
        .split(",")
        .filter(Boolean)
        .map(function (part) {
            const bits = part.split("|");
            return { key: bits[0], qty: Number.parseInt(bits[1], 10) || 0 };
        });
}

function mmGroupLines(productVariantId) {
    const itemEl = mmCartItem(productVariantId);
    return mmParseGroupKeys(itemEl && itemEl.dataset.groupKeys);
}

// Groupe re-parsé depuis la section re-rendue d'une réponse : après une mutation,
// la remise auto peut re-splitter les lignes — toujours repartir des clés fraîches.
function mmGroupLinesFromData(data, productVariantId) {
    if (!data || !data.sections || !data.sections["mm-cart"]) return null;
    const el = mmCartHTMLFromData(data);
    const row = el.querySelector(`[data-cart-item-id="${productVariantId}"]`);
    return row ? mmParseGroupKeys(row.dataset.groupKeys) : [];
}

// Amène le total du groupe à `desired`, une ligne visée par requête (les lignes
// splittées par une remise BXGY ont des clés DISTINCTES), clés relues dans chaque
// réponse. Résout avec la dernière réponse.
function mmReconcileGroup(productVariantId, desired, data, depth) {
    const group = data ? mmGroupLinesFromData(data, productVariantId) : mmGroupLines(productVariantId);
    if (group === null || (depth || 0) > 6) return Promise.resolve(data);
    const total = group.reduce(function (sum, line) {
        return sum + line.qty;
    }, 0);
    if (desired === total || !group.length) return Promise.resolve(data);

    let line, qty;
    if (desired > total) {
        line = group[0];
        qty = line.qty + (desired - total);
    } else {
        const pool = group.filter(function (l) {
            return l.qty > 0;
        });
        if (!pool.length) return Promise.resolve(data);
        line = pool[pool.length - 1];
        qty = Math.max(0, line.qty - (total - desired));
    }
    return mmAPIRequest("POST", "cart/change.js", { id: line.key, quantity: qty, sections: "mm-cart" }).then(
        function (next) {
            return mmReconcileGroup(productVariantId, desired, next, (depth || 0) + 1);
        }
    );
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const group = mmGroupLines(productVariantId);
    mmDisableCheckout(true);

    let flow;
    if (group.length === 0) {
        // Rangée sans data-group-keys (frais de mise en service) : comportement historique.
        flow = mmAPIRequest("POST", "cart/change.js", {
            id: productVariantId.toString(),
            quantity: quantity,
            sections: "mm-cart",
        });
    } else {
        flow = mmReconcileGroup(productVariantId, quantity);
    }

    flow
        .then(function (data) {
            if (!data) {
                mmDisableCheckout(false);
                return null;
            }
            // Re-rendu complet du drawer (même chemin que le flux cadeau) : plus
            // robuste que les insertions partielles quand les lignes sont splittées
            // par une remise BXGY. refreshCartFromData relance aussi la synchro des
            // frais de mise en service et le hook gr-gift.
            return refreshCartFromData(data);
        })
        .catch(function (error) {
            mmDisableCheckout(false);
            console.warn("[mm-cart] mise à jour de quantité impossible", error);
        });
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);

function mmAddOrRemoveActivationProduct(data) {
    if (data.sections["mm-cart"]) {
        // Récupérer les éléments HTML pour les produits spécifiques et les produits déclencheurs
        const triggerIds = [];
        const ProductToAdd = document.querySelector("[data-specific-products]");
        const triggerProducts = Array.from(document.querySelectorAll("[data-trigger-products] [data-trigger-id]"));

        // Créer l'array de productToAddIds
        triggerProducts.forEach(function (triggerProduct) {
            triggerIds.push(triggerProduct.dataset.triggerId);
        });

        // Vérifier si des produits déclencheurs sont présents dans le panier
        const cartItems = Array.from(document.querySelectorAll("[data-cart-item]"));

        var counter = 0;
        cartItems.forEach(function (cartItem) {
            // check if current cart item is a trigger product
            if (triggerIds.includes(cartItem.dataset.cartItemId)) {
                var itemQuantity = cartItem.dataset.itemQuantity;
                console.log("current item is a trigger product");
                counter += parseInt(itemQuantity);
                console.log("nb trigger items in cart :", counter);
            }
        });

        // Compter le nb de frais d'activation au panier
        var counterActivationProducts = 0;
        cartItems.forEach(function (cartItem) {
            if (cartItem.dataset.cartItemId == ProductToAdd.dataset.productId) {
                counterActivationProducts += parseInt(cartItem.dataset.itemQuantity);
            }
        });

        var activationsToAdd = counter - counterActivationProducts;
        console.log("counterActivationProducts", counterActivationProducts);
        console.log("activationsToAdd", activationsToAdd);

        if (activationsToAdd > 0) {
            mmAddProductToCart(ProductToAdd.dataset.productId, { quantity: activationsToAdd, force: true });
        } else if (activationsToAdd < 0) {
            var positiveQuantity = activationsToAdd * -1;
            console.log(positiveQuantity);
            console.log(ProductToAdd.dataset.productId);
            mmDecreaseActivationProductQuantity(ProductToAdd.dataset.productId, positiveQuantity);
        }else{
            mmDisableCheckout(false)
        }
    }
    return data;
}

// PROGRESS BAR
function mmProgressBar() {}

function updateCartCount(value) {
    document.querySelector(".mm-cart-count-bubble-value").innerText = value;
}

function mmDisableCheckout(booleen) {
    var btn = document.querySelector(".mm-dc-cta ");
    if (booleen) {
        btn.href = "javascript: void(0)";
        btn.classList.add("disabled");
    } else {
        btn.href = "/checkout";
        btn.classList.remove("disabled");
    }
}
